import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { ConditionValueValue } from 'components/campaigns/models/CampaignItem';
import { isTimeOfDay } from 'components/campaigns/models/CampaignTriggerCondition';
import { MultiSelectSuggest } from 'lib/MultiSelectSuggest';
import { isArrayOf, isString } from 'lib/typeguards';
import { Option } from 'lib/types';
import { ApplicationState } from 'store/store';

interface SegmentConditionProps {
    value?: ConditionValueValue;
    onChange: (value: string[]) => void;
}

export function SegmentCondition(props: SegmentConditionProps) {
    const { onChange, value } = props;
    const { customerSegments } = useSelector((state: ApplicationState) => state.audiences);
    const options = React.useMemo(
        () => customerSegments.map(item => ({ label: item.title, value: item._id })),
        [customerSegments]
    );
    const formattedValue = React.useMemo(() => {
        if (isArrayOf(isString, value) && !isArrayOf(isTimeOfDay, value)) {
            return value.map(item => options.find(option => option.value === item));
        }
        return [];
    }, [value, options]);

    const handleChange = React.useCallback(
        (value: Option[]) => {
            onChange(value ? value.map(item => item.value) : []);
        },
        [onChange]
    );
    return (
        <Box minWidth={300} maxWidth={400}>
            <MultiSelectSuggest
                value={formattedValue || null}
                isMulti
                onChange={handleChange}
                placeholder="Choose an audience"
                options={options}
                isCreatable={false}
            />
        </Box>
    );
}
